<!--
 * @Description: 这是接收实时监控的数据并转换成需要的数据传给displayHistogram.vue页面（组件）
 * @Date: 2020-07-23 15:03:11
 * @Author: 米虫
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-08-28 14:19:23
--> 
<template>
  <!-- x轴为时间变量的柱状图 ,非堆积-->
  <display-histogram
    :graph="graph"
    :extend="chartExtend"
    :data="chartData"
    v-if="(graph.radio===1||graph.radio===undefined)&&graph.x_variable===1"
    :nodata="flag"
    :resultFlag="resultFlag"
  ></display-histogram>
  <!-- x轴为时间变量的柱状图 ,堆积-->
  <display-histogram
    :graph="graph"
    :extend="chartExtendStack"
    :data="chartData"
    v-else-if="(graph.radio===2)&&graph.x_variable===1"
    :nodata="flag"
    :resultFlag="resultFlag"
  ></display-histogram>
  <!-- x轴是采集点的柱状图 -->
  <display-histogram-variable
    :graph="graph"
    :extend="chartExtendVariable"
    :data="chartDataVariable"
    :nodata="flag"
    v-else
  ></display-histogram-variable>
</template>

<script>
import displayPie from './displayPie.vue';
import displayHistogram from './displayHistogram.vue';
import displayHistogramVariable from './displayHistogram_1.vue';
import noData from '@/components/common/noData.vue';
import { getUrlKey, parseTime } from '@/config/Utils';
import { get_statistic_eqm_monitor_v2_bar } from '@/service/getData';

export default {
  props: {
    graph: {
      type: Object,
      default: () => {},
    },
    realTimeData: {
      type: Object,
      default: () => {},
    },
    id: {
      type: String,
      default: '',
    },
  },
  components: {
    displayHistogram,
    displayHistogramVariable,
  },
  data() {
    return {
      timer: '',
      chartData: {},
      resultFlag: true, //有采集点时，是否有列表数据
    };
  },
  mounted() {
    clearInterval(this.timer);
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, 5000);
  },
  activated() {
    clearInterval(this.timer);
    if (this.componentId === 'RealTime') {
      this.timer = setInterval(() => {
        this.getData();
      }, 5000);
    }
  },
  deactivated() {
    clearInterval(this.timer);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  computed: {
    flag() {
      let flag = true;
      let _self = this;
      this.graph.rules.forEach((item) => {
        if (
          this.realTimeData[item.point.name] ||
          this.realTimeData[item.point.name] === 0
        ) {
          flag = false;
          _self.noDataFlag = false;
        }
      });
      // return flag;
      return this.noDataFlag;
    },
    //x轴是采集点的柱状图的数据
    chartDataVariable() {
      let graph = [];
      this.graph.rules.forEach((item) => {
        if (Object.keys(item.point).length) {
          graph.push(item);
        }
      });

      // let rows = this.graph.rules.map((item) => {
      //     return {
      //         name: item.point.desc,
      //         value: this.realTimeData[item.point.name],
      //     };
      // });
      let rows = graph.map((item) => {
        return {
          // name: item.point.desc,
          name: item.alias ? item.alias : item.point.desc,
          value: this.realTimeData[item.point.name],
        };
      });
      let columns = ['name', 'value'];
      return {
        columns,
        rows,
      };
    },
    // x轴的样式配置
    chartExtendVariable() {
      return {
        legend: {
          show: false,
          type: 'scroll',
        },
        grid: {
          left: '10%',
          right: '10%',
        },
        type: 'time',
        // y轴设置
        yAxis: {
          show: true,
          // name: this.graph.y_unit,
          name: this.graph.y_showCoordinate ? this.graph.y_unit : '',

          position: 'left',
          nameLocation: 'start',
        },
        xAxis: {
          show: true,
          axisLabel: {
            show: true,
          },
        },
        //鼠标移上去显示的文案
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            let data = params[0];
            return `${params[0].name}：${params[0].value}`;
          },
        },
        series: {
          itemStyle: {
            //通常情况下：
            normal: {
              //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
              color: this.ColorList.bind(this),
            },
          },
        },
      };
    },
    // chartData() {
    //     let columns = ['date', 'value'];
    //     let rows = this.rows;

    //     return {
    //         columns,
    //         rows,
    //     };
    // },
    //选择时间的柱状图
    chartExtend() {
      return {
        legend: {
          show: true,
          top: 22,
          type: 'scroll',
        },
        grid: {
          left: '10%',
          right: '10%',
        },
        type: 'time',
        // y轴设置
        yAxis: {
          show: true,
          // name: this.graph.y_unit,
          name: this.graph.y_showCoordinate ? this.graph.y_unit : '',

          position: 'left',
          nameLocation: 'end',
          nameGap: 4,
        },
        dimension: ['time'],
        xAxis: {
          type: 'category',
        },
        //鼠标移上去显示的文案
        tooltip: {
          trigger: 'axis',
          // formatter: (params) => {
          //     let data = params[0];
          //     return `${params[0].name}：${params[0].value}`;
          // },
        },
        color: this.computedColorList(),
      };
    },
    // 时间堆积的柱状图
    chartExtendStack() {
      return {
        stack: { date: this.computedName() },
        legend: {
          show: true,
          top: 22,
          type: 'scroll',
        },
        grid: {
          left: '10%',
          right: '10%',
        },
        type: 'time',
        // y轴设置
        yAxis: {
          show: true,
          // name: this.graph.y_unit,
          name: this.graph.y_showCoordinate ? this.graph.y_unit : '',

          position: 'left',
          nameLocation: 'end',
          nameGap: 4,
        },
        dimension: ['time'],
        xAxis: {
          type: 'category',
        },
        //鼠标移上去显示的文案
        tooltip: {
          trigger: 'axis',
          // formatter: (params) => {
          //     let data = params[0];
          //     return `${params[0].name}：${params[0].value}`;
          // },
        },
        color: this.computedColorList(),
      };
    },
  },
  methods: {
    getData() {
      this.noDataFlag = false;
      let equipment_id = this.id;
      let date = new Date().getTime();
      let start_time = '';
      let end_time = date;
      switch (this.graph.x_unit) {
        case 'second':
          start_time = date - Number(this.graph.variable_value) * 1000;
          break;

        case 'minute':
          start_time = date - Number(this.graph.variable_value) * 60 * 1000;
          break;
        case 'hour':
          start_time = date - Number(this.graph.variable_value) * 3600 * 1000;
          break;
        case 'day':
          start_time = date - Number(this.graph.variable_value) * 86400 * 1000;
          break;
      }
      let graph = [];
      this.graph.rules.forEach((item) => {
        if (Object.keys(item.point).length) {
          graph.push(item);
        }
      });

      let field = graph.map((item) => {
        return item.point.id;
      });
      // 若有别名，显示别名
      let field_name = this.graph.rules.map((item) => {
        return item.alias || item.point.name;
      });
      // let field_name = this.graph.rules.map((item) => {
      //     return item.point.name;
      // });

      let columns = JSON.parse(JSON.stringify(field_name));
      columns.unshift('time');

      field = field.join('<>');
      get_statistic_eqm_monitor_v2_bar({
        token: getUrlKey('token')
          ? getUrlKey('token')
          : localStorage.getItem(location.host + 'token'),
        equipment_id,
        start_time,
        end_time,
        field_ids: field,
      })
        .then((res) => {
          if (!res.result.length) {
            this.resultFlag = true;
          } else {
            this.resultFlag = false;
          }
          let result = res.result;
          // let rows = res.result;
          let newResult = result.map((item) => {
            let newObj = {};
            //遍历每个对象，找到key
            for (let key in item) {
              let obj = this.graph.rules.find((el) => {
                return el.point.name === key;
              });
              // 更换别名的值
              if (obj) {
                // 判断是是否存在别名
                if (obj.alias) {
                  newObj[obj.alias] = item[key];
                } else {
                  newObj[key] = item[key];
                }
              } else {
                // 没有找到对应变量名，保持原有的
                newObj['time'] = item[key];
              }
            }
            //返回一个新的对象
            return newObj;
          });
          let rows = newResult;
          rows.forEach((item) => {
            item.time = parseTime(item.time);
          });
          this.chartData = { columns, rows };
        })
        .catch((err) => {});
    },
    // 返回色号数组
    computedColorList() {
      let colorList = [];
      this.graph.rules.forEach((item) => {
        colorList.push(item.color);
      });
      return colorList;
    },
    // 返回柱状图对应的色号
    ColorList(params) {
      let colorList = [];
      this.graph.rules.forEach((item) => {
        colorList.push(item.color);
      });
      return colorList[params.dataIndex];
    },
    computedName() {
      let nameList = [];
      this.graph.rules.forEach((item) => {
        nameList.push(item.alias || item.point.desc);
      });
      return nameList;
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
